<template>
  <div>
    <component :is="component" v-model="inputValue" v-bind="$attrs"></component>
  </div>
</template>

<script>
export default {
  name: 'SanitasInputWrapper',
  components: {
    DropDown: () => {
      return import(
        /* webpackChunkName: "sanitas-components" */
        '@/components/sanitas-components/DropDown'
      )
    },
    DateInput: () => {
      return import(
        /* webpackChunkName: "sanitas-components" */
        '@/components/sanitas-components/DateInput'
      )
    },
    PhoneNumberInput: () => {
      return import(
        /* webpackChunkName: "sanitas-components" */
        '@/components/sanitas-components/PhoneNumberInput'
      )
    },
  },

  props: {
    component: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      inputValue: '',
    }
  },
}
</script>
